import axios from 'axios';
import { handleError } from '../utils/error';
const API_URL = process.env.OXFORCE_URL;
/*
  CREATE
*/
export const postOxforce = async ({ data }) => {
    const formattedData = JSON.stringify(data);
    try {
        const token = await axios.get(`${API_URL}/csrf-token`);
        if (token) {
            const response = await axios
                .post(`${API_URL}/api/moalLead`, formattedData, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': token.csrf_token
                }
            })
                .then(async function (response) {
                return response;
            })
                .catch(function (error) {
                console.log('postOxforce', error.response.statusText);
                return error.response;
            });
            return response;
        }
    }
    catch (error) {
        handleError('postOxforce', error);
        return error.response;
    }
};
/*
  READ
*/
/*
  UPDATE
*/
/*
  DELETE
*/
//# sourceMappingURL=Oxforce.js.map